module.exports = __webpack_public_path__ + "media/img/iryo/inicial-9497865eff0ce4c1a2bfd77d4f8aae19.svg";